import { IUserSliceIniState } from './types'

const InitDocument = {
  membershipStatus: '',
  startDate: null,
  endDate: null,
  validTill: null,
  documentFullName: '',
  documentNumber: '',
  image: '',
}

const userSliceIniState: IUserSliceIniState = {
  v: null,
  guestId: null,
  userId: '',
  profileCompleted: false,
  isLoggedIn: null,
  isFirstTime: false,
  showRegistration: false,
  userLegalClauses: [],
  profileDetails: {
    id: '',
    userSummary: '',
    userLastName: '',
    userPhoneCode: '',
    userFirstName: '',
    userStripeAccountStatus: null,
    userEmail: '',
    userProfilePicture: '',
    userType: '',
    userStripeAccountId: null,
    userSubRoles: [],
    userDOB: null,
    userNationality: '',
    userAddress: '',
    userPhoneNumber: '',
    userAlternativeNumber: '',
    userSocialSecurityNumber: '',
    userLat: '',
    userName: '',
    userZone: '',
    userLong: '',
    userState: '',
    userNameNGram: [],
    userCreated: null,
    userModified: null,
    userDiscipline: '',
    userTeamMembers: [],
    userNotificationsSettings: null,
    userAccountPrivacy: false,
    userHorses: [],
    userStripeId: '',
    userSafeSupportStatus: null,
    userSafeSupportExpiry: null,
    userBackgroundCheckStatus: null,
    userBackgroundCheckExpiry: null,
    userFEI: InitDocument,
    userUSEF: InitDocument,
    userUSDF: InitDocument,
    userUSEA: InitDocument,
    userAMHA: InitDocument,
    userASHA: InitDocument,
    userAHHS: InitDocument,
    userUPHA: InitDocument,
    userWDAA: InitDocument,
    userUSHJA: InitDocument,
    userARHPA: InitDocument,
    userExtraDocument: [],
    userWebsite: '',
    userTwitter: '',
    userFacebook: '',
    userInstagram: '',
    userLinkedin: '',
    userPocDetails: {
      pocFirstName: '',
      pocLastName: '',
      pocFullName: '',
      pocPhone: '',
      pocEmail: '',
    },
  },
  userDocumentsData: {},
  vendorProfileData: {
    vendorProfileImageUrl: '',
  },
  organiserProfileData: {
    organizerProfileImageUrl: '',
  },
  userNotificationsSettings: {
    newMessages: false,
    weatherUpdates: false,
    resultUpdates: false,
    courseUpdates: false,
    paymentUpdates: false,
  },
  paymentStatus: false,
}

export { userSliceIniState }
